import * as EditorTypeAll from '../tinymce.d';
import unsubscribeIcon from './image/unsubscribe.svg';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Unsubscription = ({ editorInstance }: Props) => {
  const unsubscribeAction = () => {
    // 插入退订链接的逻辑
    const unsubscribeUrl = '{{unsubscribe_url}}';
    editorInstance.insertContent(`<a href="${unsubscribeUrl}">Unsubscribe</a>`);
  };

  return (
    <div 
      className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" 
      onClick={unsubscribeAction}
    >
      <img width="18px" height="18px" src={unsubscribeIcon} alt="Unsubscribe" />
    </div>
  );
};

export default Unsubscription;
